/**
 * `router/assessment.js`
 *  - 簡易診断ページ用スクリプト
 *
 * 使用方法:
 *  - /router/index.js initRouterで動的読み込み
 *  - import {assessmentRouter} from "./router/assessment.js";
 */


import {initMwWpForm} from "../core/wordpress/mwwpform/mwwpform.js";
import {initForm} from "../modules/form.js";


export const assessmentRouter = (data) => {
  console.log("📖 Initializing assessment page...");

  initMwWpForm(data);
  initForm();
}
